// import "./OurPartners.css";

// const OurPartners = () => {
//   return (
//     <div>
//       <div className="hero_title ">Our Partners</div>
//       <div className="hero_img ourpartner_mobile_img">
//         <img src="https://www.crestdigitel.com/wp-content/uploads/2022/09/Assets-01.jpg
// " alt="" />
//       </div>
//       <div className="container2">
//         <div className="portp_div1 container part_title part_h">
//           <h2>
//             A ‘Win – Win’ Model for <br /> Realtors, Occupants and Operators.
//           </h2>
//         </div>
//         <div className="partnerp_div1m">
//           <img src="/assets/OurPartners/OurPartnerssvg.svg" alt="" />
//         </div>
//         <div className="partnerp_div2">
//           <div className="partnerp_div21 part_h">
//             <span>OUR CUSTOMERS</span>
//             <h4>Operators</h4>
//           </div>
//           <div className="partnerp_div22">
//             <img src="/assets/OurPartners/OurPartnerssvg2.svg" alt="" />
//             <img src="/assets/OurPartners/OurPartnerssvg3.svg" alt="" />
//             <img src="/assets/OurPartners/OurPartnerssvg4.svg" alt="" />
//             <img src="/assets/OurPartners/OurPartnerssvg5.svg" alt="" />
//           </div>
//         </div>
//         <div className="partnerp_div3">
//           <div className="partnerp_div21">
//             <span>OUR CUSTOMERS</span>
//             <h4>Public, Corporate and Retail</h4>
//           </div>
//           <div className="partnerp_div31">
//             <img src="/assets/OurPartners/logos.png" alt="" />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OurPartners;
import React, { useEffect, useRef } from "react";

import "./OurPartners.css";

const OurPartners = () => {
  const observerRef = useRef(null);
  useEffect(() => {
    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        } else {
          entry.target.classList.remove("show");
        }
      });
    });

    const hiddenElementsL = document.querySelectorAll(".p_an1");
    hiddenElementsL.forEach((el) => observerRef.current.observe(el));

    const hiddenElementsR = document.querySelectorAll(".p_an2");
    hiddenElementsR.forEach((el) => observerRef.current.observe(el));

    const hiddenElementsD = document.querySelectorAll(".p_an_mid");
    hiddenElementsD.forEach((el) => observerRef.current.observe(el));

    const hiddenElements = document.querySelectorAll(".hidden");
    hiddenElements.forEach((el) => observerRef.current.observe(el));

    return () => {
      hiddenElementsL.forEach((el) => observerRef.current.unobserve(el));
      hiddenElementsR.forEach((el) => observerRef.current.unobserve(el));
      hiddenElementsD.forEach((el) => observerRef.current.unobserve(el));
      hiddenElements.forEach((el) => observerRef.current.unobserve(el));
    };
  }, []);

  

  return (
    <div>
      <div className="hero_img ourpartner_mobile_img">
      <img src="/assets/partner.jpg" alt="" />

        <div className="hero_title ">Our Partners</div>
      </div>
      <div className="container2">
        <div className="portp_div1 container part_title part_h">
          <h2>
            A ‘Win – Win’ Model for <br /> Realtors, Occupants and Operators.
          </h2>
        </div>
        <div className="partnerp_div1m p_an">
          <div className="p_an1">
            <img src="/assets/OurPartners/p2.svg" alt="" />
          </div>
          <div className="p_an_mid">
            <img src="/assets/OurPartners/p1.svg" alt="" />
          </div>
          <div className="p_an2">
            <img src="/assets/OurPartners/p3.svg" alt="" />
          </div>
        </div>
        <div className="partnerp_div1m p_svg_mobile">
          <img src="/assets/OurPartners/OurPartnerssvg.svg" alt="" />
        </div>
        <div className="partnerp_div2">
          <div className="partnerp_div21 part_h">
            <span>OUR CUSTOMERS</span>
            <h4>Operators</h4>
          </div>
          <div className="partnerp_div22">
            <img src="/assets/OurPartners/OurPartnerssvg2.svg" alt="" />
            <img src="/assets/OurPartners/OurPartnerssvg3.svg" alt="" />
            <img src="/assets/OurPartners/OurPartnerssvg4.svg" alt="" />
            <img src="/assets/OurPartners/OurPartnerssvg5.svg" alt="" />
          </div>
        </div>
        <div className="partnerp_div3">
          <div className="partnerp_div21">
            <span>OUR CUSTOMERS</span>
            <h4>Public, Corporate and Retail</h4>
          </div>
          <div className="partnerp_div31">
            <img src="/assets/OurPartners/logos.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurPartners;
